import React, { useMemo } from "react";
import FixedHeightWrapper from "app/meets/FixedHeightWrapper";
import TeamTable from "./TeamTable";
import "./TeamIndex.scss";
import { useParams, useLocation } from "react-router";

import sumBy from "lodash/sumBy";
import round from "lodash/round";
import { getTeamPoints } from "util/teamScoring";
import { useMeet } from "util/useMeet";
import { Gender } from "types";

const TeamIndex = () => {
  const { teamName } = useParams<{
    teamName: string;
  }>();
  const location = useLocation();

  const meet = useMeet();

  const data = useMemo(() => {
    const queryParams = new URLSearchParams(location.search);
    const gender = queryParams.get("gender") as Gender;
    const teamPoints = getTeamPoints({ meet, teamName, gender });
    return [{ row: "header" }, ...teamPoints.lifters];
  }, [location.search, meet, teamName]);

  return (
    <FixedHeightWrapper>
      <div className="team-index">
        <div className="team-name">
          {teamName}{" "}
          {!meet.hideTeamScoring && (
            <>: {round(sumBy(data, "teamPointsContributed") ?? 0, 3)} Points</>
          )}
        </div>
        <div className="table-wrapper">
          <TeamTable data={data} />
        </div>
      </div>
    </FixedHeightWrapper>
  );
};

export default TeamIndex;
